import React, { useState, useEffect } from 'react';
import IvisNk9Logo from '../../assets/IvisNk9Logo.png';
import './Header.css';
import { useNavigate, useLocation } from 'react-router-dom';
import UserProfileMenu from '../UserProfileMenu/UserProfileMenu';
import { useAuthContext } from '../../context/AuthContext';
import logger from '../../utils/logger';

const Header = () => {
    const [activeTab, setActiveTab] = useState('inicio');
    const { currentUser, logout } = useAuthContext();
    const navigate = useNavigate();
    const location = useLocation();

    // Sincronizar el activeTab con la ruta actual
    useEffect(() => {
        const path = location.pathname;
        
        // Determinar qué tab debe estar activo basado en la ruta
        if (path === '/' || path === '/dashboard') {
            setActiveTab('inicio');
        } else if (path === '/admin') {
            setActiveTab('admin');
        } else if (path === '/reportes') {
            setActiveTab('reportes');
        } else if (path.startsWith('/verdict/')) {
            setActiveTab('inicio'); // Los veredictos están en la página principal
        } else {
            setActiveTab('inicio'); // Por defecto
        }
    }, [location.pathname]);

    const handleLogout = async () => {
        logger.info('Cerrando sesión...', {
            currentUserEmail: currentUser?.email,
        }, 'Header');
        await logout();
        navigate('/login');
    };

    const navigationItems = [
        { id: 'inicio', label: 'Inicio', path: '/' },
        // { id: 'dictamenes', label: 'Dictámenes', path: '/verdict' },
        ...(currentUser.role === 'Administrador' ? [{ id: 'admin', label: 'Administración', path: '/admin' }, { id: 'reportes', label: 'Reportes', path: '/reportes' }] : []),
    ];

    const handleTabClick = (item) => {
        setActiveTab(item.id);
        navigate(item.path);
    };

    return (
        <header className="app-header">
            <div className="header-container">
                {/* Left Column - Logo Section (10%) */}
                <div className="header-logo-section">
                    <div className="logo-container">
                        <img src={IvisNk9Logo} alt="IVIS NK9 Logo" className="header-logo" />
                    </div>
                </div>

                {/* Right Column - Content Section (90%) */}
                <div className="header-content-section">
                    {/* Top Row - Portal Title, Main Content & Icons */}
                    <div className="header-top">
                        {/* Left Column - Portal Title (20%) */}
                        <div className="header-portal-section">
                            <span className="portal-title">Portal de Inspectores</span>
                        </div>

                        {/* Center Column - Title and Description (60%) */}
                        <div className="header-center">
                            <h1 className="app-title">Módulo Integrado de Inspecciones</h1>
                            <p className="app-description">
                                Administra, actualiza y lleva a cabo inspecciones de vehículos pendientes de póliza.
                            </p>
                        </div>

                        {/* Right Column - Icons (20%) */}
                        <div className="header-actions">
                            {/* <button className="icon-button notification-button">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                                    <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                                </svg>
                            </button> */}
                            <UserProfileMenu user={currentUser} onLogout={handleLogout} />
                        </div>
                    </div>

                    {/* Bottom Row - Navigation */}
                    <div className="header-navigation">
                        <nav className="navigation-tabs">
                            {navigationItems.map((item) => (
                                <button
                                    key={item.id}
                                    className={`nav-tab ${activeTab === item.id ? 'active' : ''}`}
                                    onClick={() => handleTabClick(item)}
                                >
                                    {item.label}
                                </button>
                            ))}
                        </nav>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;